import SaveAndShareSticky from '../Buttons/SaveAndShareSticky';
import StartOver from '../Buttons/StartOver';
import LoginOrRegister from '../Buttons/LoginOrRegister';
import Logout from '../Buttons/Logout';
import AdvisorNotesMenuItem from '../Buttons/AdvisorNotes';

export default function MenuActionsDefault({ toggleMenuState, isAdvisorView }) {
	return (
		<>
			<SaveAndShareSticky
				classes={['saveShare', 'plain', 'mb-0']}
				toggleMenuState={toggleMenuState}
				isAdvisorView={isAdvisorView}
			/>
			<StartOver
				classes={['plain', ['startover'], 'is-marginless', 'startOver']}
				toggleMenuState={toggleMenuState}
				isAdvisorView={isAdvisorView}
			/>
			<LoginOrRegister
				classes={['mb-0', 'half', 'menu-btn', 'loginRegister']}
				toggleMenuState={toggleMenuState}
			/>

			<AdvisorNotesMenuItem/>
			<Logout classes={['plain', ['startover'], 'is-marginless', 'logout']} toggleMenuState={toggleMenuState} />
		</>
	);
}
